import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d07c5ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4" }, null, -1))
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = { class: "input-group mt-3 mb-1" }
const _hoisted_6 = { class: "input-group-text text-truncate" }
const _hoisted_7 = { class: "input-group-text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 p-0" }, [
    /*#__PURE__*/_createElementVNode("div", {
      id: "map",
      style: {"height":"50vh"}
    })
  ])
], -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.renderComponent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t.longitude), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: "Longitude",
                onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateMarker && _ctx.updateMarker(...args))),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lngLat[0]) = $event)),
                "aria-label": "Longitude"
              }, null, 544), [
                [_vModelText, _ctx.lngLat[0]]
              ]),
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t.latitude), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: "Latitude",
                onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateMarker && _ctx.updateMarker(...args))),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lngLat[1]) = $event)),
                "aria-label": "Latitude"
              }, null, 544), [
                [_vModelText, _ctx.lngLat[1]]
              ]),
              _createElementVNode("button", {
                class: "btn btn-outline-info",
                type: "button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.geoLocate && _ctx.geoLocate(...args)))
              }, _toDisplayString(_ctx.$t.get), 1)
            ])
          ])
        ]),
        _hoisted_8,
        _withDirectives(_createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "btn btn-outline-secondary",
              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleImageLayer && _ctx.toggleImageLayer(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.imageLayerVisible ? 'Hide' : 'Show') + " Image Layer", 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "btn btn-outline-secondary",
              onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changeStyle && _ctx.changeStyle(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.isSatelliteView ? 'Switch to Def View' : 'Switch to Sat View'), 1)
          ])
        ], 512), [
          [_vShow, _ctx.showImageButton]
        ])
      ]))
    : _createCommentVNode("", true)
}